const headerLogo = document.querySelectorAll(".header__logo");
const announcementTabs = document.querySelectorAll(".announcement-bar__tab");
const announcementBar = document.querySelector(".announcement-bar");
const header = document.querySelector("#shopify-section-header");
const transparentHeader = document.querySelectorAll(".transparent__header");
const allSection = document.querySelectorAll(".shopify-section");
const headerHamburger = document.querySelector(".header__hamburger");
const headerMobile = document.querySelector(".header__mobile");
const mainBanner = document.querySelector('[data-section-type="banner"]');

if (mainBanner) {
  mainBanner.setAttribute(
    "style",
    `height: calc(100vh - ${announcementBar.offsetHeight}px)`
  );
}

const headerSearch = document.querySelector(".header__wrapper-nav--search");
const headerSearchBlock = document.querySelector(".header__search-block");
const headerSearchClose = document.querySelector(".header__search-close");
const headerSearchMob = document.querySelector(".header__mobile-link.search");
const headerSearchBlockMob = document.querySelector(
  ".header__search-block-mobile"
);
const headerSearchCloseMob = document.querySelector(
  ".header__search-close--mobile"
);

headerSearchClose.addEventListener("click", () => {
  headerSearchBlock.classList.remove("is-show");
  document.body.classList.remove("overflow");
  header.querySelector(".header__wrapper").classList.remove("with__background");
});

headerSearch.addEventListener("click", () => {
  headerSearchBlock.classList.toggle("is-show");
  document.body.classList.toggle("overflow");
  header.querySelector(".header__wrapper").classList.toggle("with__background");
});

announcementTabs.forEach((tab) => {
  if (tab.dataset.id == localStorage.getItem("AnaOno")) {
    tab.classList.add("active");
  }
  tab.addEventListener("click", () => {
    localStorage.setItem("AnaOno", tab.dataset.id);
  });
});

function setHomeUrl(logo) {
  logo.forEach((item) => {
    item.href = `${localStorage.getItem("AnaOno")}`;
  });
}

setHomeUrl(headerLogo);

function activeHeader() {
  allSection.forEach((section) => {
    if (
      section.querySelector(".transparent__header") == null &&
      section != header
    ) {
      const startSection =
        section.offsetTop - header.offsetHeight + announcementBar.offsetHeight;
      const endSection =
        section.offsetTop +
        section.offsetHeight -
        header.offsetHeight +
        announcementBar.offsetHeight;

      if (
        window.pageYOffset >= startSection &&
        window.pageYOffset <= endSection
      ) {
        header
          .querySelector(".header__wrapper")
          .classList.add("with__background");
      }
    }
  });
}

activeHeader();

window.addEventListener("scroll", () => {
  const announceBar = document.querySelector(".announcement-bar");
  if (window.pageYOffset >= announcementBar.offsetHeight) {
    header.style.top = `-${announceBar.offsetHeight}px`;
    // mainBanner.setAttribute('style',`height: 100vh`);
  } else {
    header.style.top = `0px`;
    if (mainBanner) {
      mainBanner.setAttribute(
        "style",
        `height: calc(100vh - ${announceBar.offsetHeight}px)`
      );
    }
  }
  transparentHeader.forEach((section) => {
    const startSection =
      section.offsetTop - header.offsetHeight + announcementBar.offsetHeight;
    const endSection =
      section.offsetTop +
      section.offsetHeight -
      header.offsetHeight +
      announcementBar.offsetHeight;

    if (
      window.pageYOffset >= startSection &&
      window.pageYOffset <= endSection
    ) {
      header
        .querySelector(".header__wrapper")
        .classList.remove("with__background");
    }
  });

  activeHeader();
});

headerHamburger.addEventListener("click", () => {
  if (window.pageYOffset >= announcementBar.offsetHeight) {
    headerMobile.style.height = `calc(100vh - ${
      header.offsetHeight - announcementBar.offsetHeight
    }px)`;
  } else {
    headerMobile.style.height = `calc(100vh - ${header.offsetHeight}px)`;
  }
  header.querySelector(".header__wrapper").classList.add("with__background");
  headerHamburger.classList.toggle("active");
  headerMobile.classList.toggle("active");

  document.body.classList.toggle("overflow");
});

function setPaddingBodyHandler() {
  const announceBar = document.querySelector(".announcement-bar");
  if (
    !document.querySelector(".template-index") &&
    !document.querySelector(".suffix-medical") &&
    !document.querySelector(".template-collection") &&
    !document.querySelector(".template-page-about") &&
    !document.querySelector(".template-page-careers") &&
    !document.querySelector(".template-blog") &&
    !document.querySelector(".template-article") &&
    !document.querySelector(".template-page-rewards")
  ) {
    document.body.style.paddingTop = `${
      document.querySelector("#shopify-section-header").offsetHeight
    }px`;
  } else {
    document.body.style.paddingTop = `${
      announceBar ? announceBar.offsetHeight : 0
    }px`;
  }
}

setPaddingBodyHandler();
window.addEventListener("resize", setPaddingBodyHandler);
window.addEventListener("orientationchange", setPaddingBodyHandler); 
